'use strict';

var y = require('yup');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var y__namespace = /*#__PURE__*/_interopNamespaceCompat(y);

const name = 'ssn';
const SSN_ERROR = 'invalidSsn';
// https://en.wikipedia.org/wiki/Social_Security_number#Valid_SSNs
const SSN_REGEX = /^(?!000|666)[0-8]\d{2}(?!00)\d{2}(?!0000)\d{4}$/;
y__namespace.addMethod(y__namespace.StringSchema, name, function(options) {
    return this.test({
        name,
        message: {
            key: options?.error ?? SSN_ERROR
        },
        test: (value)=>{
            if (!value) {
                return false;
            }
            // remove separators from string, only verify the number
            value = value.replaceAll(/-/g, '');
            return SSN_REGEX.test(value);
        }
    });
});

exports.SSN_ERROR = SSN_ERROR;
//# sourceMappingURL=ssn.js.map
